import { render, staticRenderFns } from "./VersionComparator.vue?vue&type=template&id=4e619fd6"
import script from "./VersionComparator.vue?vue&type=script&lang=js"
export * from "./VersionComparator.vue?vue&type=script&lang=js"
import style0 from "./VersionComparator.vue?vue&type=style&index=0&id=4e619fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports